import React, { useEffect } from 'react';
import { EmployeeExperienceStyles } from './styles';
import {
  BannerEmployeeExperience,
  BusinessEmployeeExperience,
  ImpactEmployeeExperience,
  MethodologyEmployeeExperience,
  StoryEmployeeExperience,
  WhyEmployeeExperience,
} from '../../components';
import MetaFromApi from '../../components/metaFromApi/MetaFromApi';

export const EmployeeExperience = () => {
  useEffect(() => {}, []);

  return (
    <EmployeeExperienceStyles>
      <MetaFromApi slug="employee-experience" />
      <BannerEmployeeExperience />
      <BusinessEmployeeExperience />
      <WhyEmployeeExperience />
      <ImpactEmployeeExperience />
      <MethodologyEmployeeExperience />
      <StoryEmployeeExperience />
    </EmployeeExperienceStyles>
  );
};
